<template>
  <component :is="component">
    <slot/>
  </component>
</template>

<script>



import VuebaseLayoutVue from './layouts/VuebaseLayout.vue';

export default {
  name: 'App',
  components: {
    VuebaseLayoutVue
  },

  data: () => ({    
  }),

   mounted() {
    // document.body.style.zoom = "90%";
  },

  beforeDestroy() {
    document.body.style.zoom = "100%";
  },

  computed: {
    component() {
      return VuebaseLayoutVue
    }
  }

};
</script>


<style>

</style>

